import React, { useContext, useEffect, useState } from 'react';
import useTranslation from '@hooks/useTranslation';
import FilterSearchGroup from '../../../MainPages/Components/FilterSearchGroup';
import SearchGroup from '../../../MainPages/Components/FilterSearchGroup/Components/SearchGroup';
import { Button, Select as ReactSelect, TextInput } from '@components';
import {
    InputGroup,
    InputWrap,
    SearchWrap,
    SelectGroup,
} from '../../../MainPages/Components/FilterSearchGroup/Components/Part';
import SearchButtonArea from '../../../MainPages/Components/FilterSearchGroup/Components/SearchButtonArea';
import { makeParameter } from '../../util/commons';
import { IotItemInfoLogDispatchContext, IotItemInfoLogStateContext } from '../index';
import { reset, setKeyword, setManipulationType, setSearchOption } from '../iotItemInfoLogReducer';

/**
 *
 * Iot 아이템 정보 로그 검색 기능 컴포넌트
 *
 * @param {function} promise Iot 아이템 정보 로그 리스트 호출 callback
 *
 * @author jinbeom-jung
 * */

const Search = ({ promise }) => {
    const t = useTranslation('Iot Item Information Log');
    const dispatch = useContext(IotItemInfoLogDispatchContext);
    const { keyword, searchOption, manipulationType } = useContext(IotItemInfoLogStateContext);

    const searchOptions = [
        { value: '', label: t('Search Option', 'Search') },
        { value: 'targetNum', label: t('IoT Item No.') },
        { value: 'targetId', label: t('IoT Item ID') },
        { value: 'targetName', label: t('IoT Item Name') },
    ];

    const manipulationOptions = [
        { value: '', label: t('Type of Data Revision', 'CommonColumn') },
        { value: 'INSERT', label: t('Register') },
        { value: 'UPDATE', label: t('Modify') },
        { value: 'DELETE', label: t('Delete') },
    ];

    useEffect(() => {
        dispatch(
            reset({
                searchOption: searchOptions[0],
                manipulationType: manipulationOptions[0],
            }),
        );
    }, []);

    const handleInputChange = e => {
        const { value } = e.target;
        dispatch(setKeyword(value));
    };
    const handleManipulationOptions = selected => dispatch(setManipulationType(selected));

    const handleSelectValueChange = selected => {
        const { value } = selected;
        if (value === '') {
            dispatch(setKeyword(''));
        }
        dispatch(setSearchOption(selected));
    };

    const handleRefreshClick = () => {
        dispatch(
            reset({
                keyword: '',
                searchOption: searchOptions[0],
                manipulationType: manipulationOptions[0],
            }),
        );
        promise();
    };

    const handleSearchClick = () => {
        const result = makeParameter({
            searchRequirement: {
                manipulationType: manipulationType.value,
                keyword: keyword,
                opt: searchOption.value,
            },
        });
        promise(result);
    };

    return (
        <FilterSearchGroup className={'p-0'}>
            <SearchGroup>
                <div className={'d-flex'}>
                    <SelectGroup className={'mr-1'}>
                        <ReactSelect
                            name="manipulationType"
                            placeholder={t('Type of Data Revision', 'CommonColumn')}
                            value={manipulationType}
                            options={manipulationOptions}
                            onChange={handleManipulationOptions}
                            customControlStyles={{ width: '100%' }}
                            customMenuStyles={{ width: '100%' }}
                            customOptionStyles={{ width: '100%' }}
                        />
                    </SelectGroup>
                    <SearchWrap>
                        <SelectGroup>
                            <ReactSelect
                                name="selectInput"
                                placeholder={t('Search Option', 'Search')}
                                value={searchOption}
                                options={searchOptions}
                                onChange={handleSelectValueChange}
                                customControlStyles={{ width: '100%' }}
                                customMenuStyles={{ width: '100%' }}
                                customOptionStyles={{ width: '100%' }}
                            />
                        </SelectGroup>
                        <InputWrap>
                            <InputGroup>
                                <TextInput
                                    type="text"
                                    size={60}
                                    placeholder={t(
                                        'Please Enter your search keyword after selecting search option.',
                                        'Search',
                                    )}
                                    name="name"
                                    value={keyword}
                                    handleChange={handleInputChange}
                                    disabled={!searchOption.value}
                                />
                            </InputGroup>
                        </InputWrap>
                    </SearchWrap>
                    <SearchButtonArea>
                        <div className={'d-flex'}>
                            <Button className="btn-secondary mr-2" onClick={handleSearchClick}>
                                {t('Search', 'Search')}
                            </Button>
                            <Button
                                className="btn-line btn-icon-only"
                                iconName="refresh"
                                onClick={handleRefreshClick}
                            />
                        </div>
                    </SearchButtonArea>
                </div>
            </SearchGroup>
        </FilterSearchGroup>
    );
};

export default Search;
